import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnClick($event)))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ]));
}
